import { salesOrders, salesOrderLines } from "@briolin/db";
import type { TestDb } from "@briolin/db/src/testing.js";
import type { CheckoutInput } from "@briolin/shared";
import { resolveDisplayPrice } from "./catalog.js";
import { postOrderReserve } from "./documents/sales-order.js";
import { computeCartTotals } from "./cart.js";

type Db = TestDb;

export async function createCheckoutOrder(
  db: Db, input: CheckoutInput,
): Promise<{ orderId: string; totalKopecks: number }> {
  // резолвим цену по контрагенту и мёрзнем на строке заказа (модель №1)
  const pricedLines = await Promise.all(input.lines.map(async (l) => ({
    productId: l.productId,
    warehouseId: l.warehouseId,
    qty: l.qty,
    priceKopecks: await resolveDisplayPrice(db, { counterpartyId: input.counterpartyId, productId: l.productId }),
  })));

  const [order] = await db.insert(salesOrders)
    .values({ counterpartyId: input.counterpartyId })
    .returning();
  await db.insert(salesOrderLines).values(pricedLines.map((l) => ({
    orderId: order.id,
    productId: l.productId,
    warehouseId: l.warehouseId,
    qty: l.qty,
    priceKopecks: l.priceKopecks,
  })));

  // мягкий резерв через движок №1
  await postOrderReserve(db, order.id);

  const { subtotalKopecks } = computeCartTotals(pricedLines);
  const totalKopecks = subtotalKopecks + (input.deliveryCostKopecks ?? 0);
  return { orderId: order.id, totalKopecks };
}
